import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate('/admin/login');
      return;
    }
    const sid = m[1];
    (async () => {
      try {
        const r = await api.post('/auth/session', { session_id: sid });
        setUser(r.data);
        if (r.data.is_admin) {
          navigate('/admin', { replace: true, state: { user: r.data } });
        } else {
          navigate('/admin/denied', { replace: true });
        }
      } catch (e) {
        navigate('/admin/login', { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F4]">
      <div className="text-center">
        <div className="display text-[28px] text-[#957340]">Devil Tattooz</div>
        <div className="mt-3 text-[11px] tracking-[0.32em] uppercase text-[#8A8275]">Authentification…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
